import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatDialogCloseEvent } from '../../../const';

@Component({
  selector: 'app-view-ticket-description',
  templateUrl: './view-ticket-description.component.html'
})
export class ViewTicketDescriptionComponent {

  description: string = "";
  constructor( public dialog: MatDialog, 
    @Optional() public dialogRef: MatDialogRef<ViewTicketDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any ) {}


  ngOnInit(): void {
    this.description = this.data.Description;
  }

  cancel(){
    this.dialogRef.close({event: MatDialogCloseEvent.CANCELLED});
  }
}
